import React from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import ReportSubmissionGroupGrid from '@/components/reporting/reportSubmissionGroupGrid'
import Resx from '@/components/Resx'

class ReportSubmissionGroups extends React.Component {
  render () {
    return (
      <Main>
        <MainTop>
          <MainTopTitle>
            <Resx name='Reporting.ReportGroupSubmissionsTitle' />
          </MainTopTitle>
        </MainTop>
        <MainBody>
          <ReportSubmissionGroupGrid forecasting={false} detailUrlFormat='/report-submission-groups/{0}/report-submissions' />
        </MainBody>
      </Main>
    )
  }
}

export default ReportSubmissionGroups



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportSubmissionGroups/reportSubmissionGroups.js